<template>
    <div>
        <div style="display: flex; flex-direction: column">
            <div style="width: 50%;">
                <VueDateFilter @dateFilterChange="dateFilterApplied" />
            </div>
            <div class="form-group" style="margin-top: 16px; width: 50%;">
                <label for="ow">Select Owned Website</label>

                <select class="form-control" @change="selectOwnedWebsite" id="ow">
                    <option  selected value=""></option>
                    <option v-for="option in options" :value="option.id">{{ option.name }}</option>
                </select>
            </div>
        </div>
        <div v-if="countryTraffic.length === 0" class="alert alert-info" role="alert">
            There is no traffic for the selected filters
        </div>
        <div v-if="!isLoading && countryTraffic.length > 0"  style="display: flex; flex-direction: row; justify-content: center">
            <div style="width: 50%; display: flex; flex-direction: column">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Country</th>
                        <th scope="col">Generated Traffic</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, index) in paginatedItems">
                        <th scope="row">{{index + 1}}</th>
                        <td>{{ row.name }}</td>
                        <td>{{ row.traffic }} of {{ allTraffic }} <span class="badge">{{ calculatePercentage(row.traffic) }} % </span></td>
                    </tr>

                    </tbody>
                </table>
                <Pagination
                    @pageChange="changePage"
                    :page-count="pageCount"
                />

            </div>
            <div style="width: 50%; display:flex; justify-content: center">
                <PieChart :data="chartData" :options="chartOptions" />
            </div>
        </div>
        <div v-if="isLoading" class="loader" id="loader-1"></div>

    </div>
</template>

<script>
import VueDateFilter from "../../generic/VueDateFilter";
import PieChart from "../charts/PieChart";
import Pagination from "../../common/Pagination";

const PER_PAGE = 10;
export default {
    name: "TrafficLogCountryReport",
    components: {Pagination, PieChart, VueDateFilter},
    props: [
        'ownedWebsites'
    ],
    data() {
        return {
            chartOptions: {
                hoverBorderWidth: 20
            },

            isLoading: false,
            filters: {
                start: null,
                end: null,
                owned_website_id: null,
            },
            options: JSON.parse(this.ownedWebsites),
            countryTraffic: [],
            allTraffic: 0,
            pageCount: 0,
            pageNumber: 0,
        }
    },

    computed: {
        chartData() {
            return {
                hoverBackgroundColor: "red",
                hoverBorderWidth: 10,
                labels: this.countryTraffic.map(item => item.name),
                datasets: [
                    {
                        label: "Data One",
                        backgroundColor: this.countryTraffic.map((item) => {
                            return this.getRandomColor()
                        }),
                        data: this.countryTraffic.map(item => item.traffic)
                    }
                ]
            }
        },
        paginatedItems() {
            const start = this.pageNumber * PER_PAGE,
                end = start + PER_PAGE;
            return this.countryTraffic.slice(start, end);
        }
    },

    methods: {
        dateFilterApplied(dateFromTimestamp, dateToTimestamp, type) {
            this.filters.start = dateFromTimestamp;
            this.filters.end = dateToTimestamp;
            this.fetch()
        },

        fetch() {
            const filters = this.filters;
            this.isLoading = true;
            axios.post('traffic-log-country-report/getReport', filters).then((res) => {
                this.isLoading = false;
                this.countryTraffic = res.data.country_traffic;
                this.allTraffic = res.data.traffic_count[0];
                this.pageCount = Math.ceil(res.data.country_traffic.length / PER_PAGE);

            }).catch(({response, request}) => {
                if(response.data && response.data.errors) {
                    for (const property in response.data.errors) {
                    }
                }
                this.isLoading = false;
            })
        },

        selectOwnedWebsite(event) {
            this.filters.owned_website_id = event.target.value;
            this.fetch();
        },

        calculatePercentage(traffic) {
            return ((traffic / this.allTraffic) * 100).toFixed(2);
        },

        getRandomColor() {
            var letters = '0123456789ABCDEF';
            var color = '#';
            for (var i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },
        changePage(fromPage, toPage) {
            this.pageNumber = toPage;
        },
    }
}
</script>

<style scoped lang="scss">
    @import "../../../../../sass/admin-panel/partials/_loader.scss";
</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/admin/traffic-log-country-report/TrafficLogCountryReport.vue